import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'APP Registrasi Online UM';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'

//export const APP_URL='http://localhost:3000'
export const APP_URL=''
export const WEB_URL=env.WEB_URL

export const X_API_KEY=env.X_API_KEY;

export const VERSION_APP = env.VERSION_APP;

export const THEME_CONFIG = {
	"navType": "TOP",
	"sideNavTheme": "SIDE_NAV_LIGHT",
	"navCollapsed": false,
	"topNavColor": "#2e3192ff",
	"headerNavColor": "",
	"locale": "en",
	"currentTheme": "light",
	"direction": "ltr"
}
